import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Select from 'react-select';
import Swal from "sweetalert2";
import html2canvas from 'html2canvas';
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import { MdDownloadForOffline } from "react-icons/md";

function RateCal({ switchToBooking }) {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [getCountry, setGetCountry] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [modalIsOpen3, setModalIsOpen3] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRow2, setSelectedRow2] = useState(null);

  const handleOpenModal = (row) => {
    setSelectedRow(row);
    setModalIsOpen(true);
  };
  const handleOpenModal2 = async (row) => {
    setSelectedRow2(row);
    setModalIsOpen3(true);
  };
  const loginData = JSON.parse(localStorage.getItem("Login"));
  const [editIndex, setEditIndex] = useState(null);
  const [totalVolWt1, setTotalVolWt1] = useState(0);
  const [totalActWt1, setTotalActWt1] = useState(0);
  const [totalChargeWt1, setTotalChargeWt1] = useState(0);
  const [submittedData, setSubmittedData] = useState([]);
  const [volumetricData, setVolumetricData] = useState({
    Length: 0,
    Width: 0,
    Height: 0,
    Qty: 0,
    DivideBy: 0,
    cft: 0,
    VolmetricWt: 0,
    ActualWt: 0,
    ChargeWt: 0
  })

  const [formData, setFormData] = useState({

    ShipmentType: "Domestic",     // Dox | Non Dox | Rate Per Kg
    Weight: "",
    CountryName: "",
    PostalCode: "",
    invoice: "",
  });

  useEffect(() => {
    const totalVol1 = submittedData.reduce(
      (acc, d) => acc + parseFloat(d.VolmetricWt || 0), 0
    );
    const totalAct1 = submittedData.reduce(
      (acc, d) => acc + parseFloat(d.ActualWt || 0), 0
    );
    const totalCharge1 = submittedData.reduce(
      (acc, d) => acc + parseFloat(d.ChargeWt || 0), 0
    );



    setTotalVolWt1(totalVol1);
    setTotalActWt1(totalAct1);
    setTotalChargeWt1(totalCharge1);
    if (submittedData.length == 0) {
      return;
    }

    setFormData((pre) => (
      {
        ...pre,
        Weight: Math.max(totalAct1, totalCharge1, totalVol1)

      }
    ))
  }, [submittedData]);

  useEffect(() => {
    if (volumetricData.Length == 0 || volumetricData.Width == 0 || volumetricData.Height == 0 || volumetricData.Qty == 0 || volumetricData.DivideBy == 0) {
      setVolumetricData((prev) => (
        {
          ...prev,
          VolmetricWt: 0,
        }
      ))
      return;
    }
    if (volumetricData.Length && volumetricData.Width && volumetricData.Height && volumetricData.Qty && volumetricData.DivideBy) {
      console.log(volumetricData)
      let ans = 1;
      ans = ans * Number(volumetricData.Length);
      ans = ans * Number(volumetricData.Width);
      ans = ans * Number(volumetricData.Height);
      console.log(ans);
      if (volumetricData.cft) ans = ans * volumetricData.cft;
      console.log(ans);
      ans = ans / volumetricData.DivideBy;
      console.log(ans);
      ans = ans * Number(volumetricData.Qty);
      console.log(ans);
      setVolumetricData((prev) => (
        {
          ...prev,
          VolmetricWt: ans.toFixed(2),
        }
      ))
    }
    else {
      setVolumetricData((prev) => (
        {
          ...prev,
          VolmetricWt: 0,
        }
      ))
    }
  }, [volumetricData.Length, volumetricData.Width, volumetricData.Height, volumetricData.Qty, volumetricData.DivideBy])

  useEffect(() => {
    setVolumetricData((pre) =>
    ({
      ...pre,
      ChargeWt: Math.max(volumetricData.ActualWt || 0, volumetricData.VolmetricWt || 0)

    }))
  }, [volumetricData.ActualWt, volumetricData.VolmetricWt])

  const handleAddRow = (e) => {
    e.preventDefault();

    if (!volumetricData.ActualWt || !volumetricData.ChargeWt || !volumetricData.VolmetricWt) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please fill in the empty fields.',
        confirmButtonText: 'OK',
      });
      return;
    }
    if (!volumetricData.Qty) {
      Swal.fire({
        icon: 'warning',
        title: 'Qty Zero',
        text: 'Qty should not be zero.',
        confirmButtonText: 'OK',
      });
      return;
    }
    if (editIndex !== null) {
      // update existing row
      const updated = [...submittedData];
      updated[editIndex] = volumetricData;
      setSubmittedData(updated);
      setEditIndex(null);
    } else {
      // add new row
      setSubmittedData((prev) => [...prev, volumetricData]);
    }
    setVolumetricData(pre => ({
      ...pre,
      Length: 0,
      Width: 0,
      Height: 0,
      Qty: 0,
      VolmetricWt: 0,
      ActualWt: 0,
      ChargeWt: 0,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVolumetricData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  const handlePinCodeChange = async (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);

    setFormData((prev) => ({
      ...prev,
      PostalCode: value,
    }));

    // Fetch city when 6 digits entered
    if (value.length === 6) {
      try {
        const response = await getApi(`/Master/PincodeFinder?pincode=${value}`);
        if (response.status === 1 && Array.isArray(response.data) && response.data.length > 0) {
          const { City_Name } = response.data[0];

          setFormData((prev) => ({
            ...prev,
            CountryName: City_Name,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            CountryName: "",
          }));
        }
      } catch (error) {
        console.log("Error fetching city:", error);
      }
    }
  };

  const handleDownload = async () => {
    const element = document.getElementById("download");

    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const image = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = image;
    link.download = `${selectedRow2?.Vendor_Name || "RateCard"}.png`;
    link.click();
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  }
  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  }
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  /* ================= COUNTRY LIST ================= */
  useEffect(() => {
    const fetchData = async (setData, Product_Type) => {

      try {
        const response = await getApi(`/Master/GetInterDomestic?Product_Type=${Product_Type}`);
        const data = response.Data || response.data
        // Check if the response contains data, then update the corresponding state
        if (data) {
          setData(Array.isArray(data) ? data : []);
        } else {
          setData([]);
        }
      } catch (err) {
        console.error(`Error fetching data from /Master/GetInterDomestic:`, err);

      }

    };
    const Product_Type = formData.ShipmentType;
    fetchData(setGetCountry, Product_Type);
  }, [formData.ShipmentType])



  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.Weight || !formData.CountryName) {
      Swal.fire("Warning", "Weight and Country are required", "warning");
      return;
    }

    setLoading(true);

    try {
      const payload = {


        Weight: Number(formData.Weight),
        CountryName: formData.CountryName,
        PostalCode: formData.PostalCode?.trim() || null,
        InvoiceValue: formData.invoice,
      };

      const response = await postApi(
        "/Master/VendorRateSearchonWebsite",
        payload
      );

      if (response?.status === 1) {

        const temp = JSON.parse(localStorage.getItem("Login"));
        const data = response.data;
        setData(data || []);
        setCurrentPage(1);
      } else {
        setData([]);
        Swal.fire("Info", response?.message || "No data found", "info");
      }
    } catch (err) {
      Swal.fire("Error", "Failed to fetch rate", "error");
    } finally {
      setLoading(false);
    }
  };

  /* ================= PAGINATION ================= */
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(data.length / rowsPerPage);

  const filteredRows = currentRows?.filter((row) =>
    loginData?.UserType === "Admin" ||
    (
      loginData?.UserType === "User" &&
      (
        !loginData?.Customer_Code ||
        row?.Customer_Code === loginData?.Customer_Code
      ) &&
      (
        !loginData?.RateType?.length ||
        loginData?.RateType
          ?.map(x => x?.toLowerCase().replace("-", " ").trim())
          .includes(
            row?.Booking_Type?.toLowerCase().replace("-", " ").trim()
          )
      )
    )
  );

  /* ================= LOGO MAP ================= */

  /* ================= UI ================= */
  return (
    <>
      <style>
        {`
    .table .tr-input td, .custom-th th {
    padding: 3px !important;
  }
    .table td input{
    height:36px
    }
   
    
`}
      </style>
      <div className="body">
        <div className="container1">

          {/* ================= FORM ================= */}
          <form onSubmit={handleSubmit} >
            <div className="fields2">




              {/* Dox / Non Dox / Rate Per Kg */}
              <div className="input-field2">
                <label>Service Type</label>
                <select
                  value={formData.ShipmentType}
                  onChange={e =>
                    setFormData({ ...formData, ShipmentType: e.target.value })
                  }
                >
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>

                </select>
              </div>

              {/* Zip */}
              <div className="input-field2">
                <label>Zip Code</label>
                <input
                  className='input'
                  placeholder='Enter Zip Code'
                  type="text"
                  value={formData.PostalCode}
                  onChange={handlePinCodeChange}
                />
              </div>

              {/* Country */}
              <div className="input-field3">
                <label>City / Country</label>
                <Select
                  className="blue-selectbooking"
                  classNamePrefix="blue-selectbooking"
                  options={getCountry.map(c => ({
                    value: c.City_Name,
                    label: c.City_Name
                  }))}
                  value={
                    formData.CountryName
                      ? { value: formData.CountryName, label: formData.CountryName }
                      : null
                  }
                  onChange={(selected) =>
                    setFormData({ ...formData, CountryName: selected?.value || "" })
                  }
                  placeholder="Select Country"
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
              </div>



              {/* Weight */}
              <div className="input-field3">
                <label>Weight</label>
                <div style={{ display: "flex", gap: "5px" }}>
                  <input
                    style={{ flex: 1 }}
                    type="number"
                    className='input'
                    placeholder="Enter Weight"
                    step="0.01"
                    min="0"
                    value={formData.Weight}
                    onChange={(e) => {
                      const value = e.target.value;

                      // prevent negative
                      if (Number(value) < 0) return;

                      setFormData({
                        ...formData,
                        Weight: value
                      });
                    }}
                  />
                  <button
                    type="button"
                    className="ok-btn2"
                    onClick={() => setModalIsOpen2(true)}
                    style={{ height: "35px", width: "40px" }}
                  >
                    <i className="bi bi-calculator" style={{ fontSize: "20px" }}></i>
                  </button>

                </div>




              </div>


              <div className="bottom-buttons" style={{ marginTop: "23px" , marginLeft:"10px"}}>
                <button className="ok-btn" type="submit">Submit</button>
              </div>


              <div className="input-field2">
                <label>Invoice Value</label>
                <input
                  type="number"
                  className='input'
                  placeholder='Enter Invoice Value'
                  step="0.01"
                  value={formData.invoice}
                  onChange={(e) => {
                    const value = e.target.value;

                    // prevent negative
                    if (Number(value) < 0) return;

                    setFormData({ ...formData, invoice: e.target.value })
                  }}

                />
              </div>


            </div>
          </form>

          {/* ================= TABLE / LOADER ================= */}
          {loading ? (
            <div className="loader"></div>
          ) : (
            <div className='table-container'>
              <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
                <thead>
                  <tr>
                    <th className='w-60'>Sr.No</th>
                    <th>Dox / Spx</th>
                    <th>Vendor Logo</th>
                    <th>Vendor Name</th>
                    <th className='w-60'>Download</th>
                    <th>Mode</th>
                    <th>Weight</th>
                    <th>Per Kg</th>
                    <th>Cost (₹)</th>

                    <th>City / Country</th>
                    <th>Zone Name</th>
                    <th>Rate Type</th>
                    <th>Customer Name</th>
                    <th>Booking Type</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows.map((row, index) => (
                    <tr key={index} style={{ fontSize: "12px" }}>
                      <td className='w-60'>{index + 1}</td>
                      <td>{row.Dox_Spx}</td>
                      <td>
                        <img
                          src={row.Vendor_Img}
                          alt="Logo"
                          style={{ width: "80px", height: "40px" }}
                        />
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          style={{ fontSize: "14px", fontWeight: "bold", color: "#055a0f" }}

                          onClick={() => switchToBooking(row)}

                        >
                          {row.Vendor_Name}

                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          style={{ fontSize: "20px", fontWeight: "bold", color: "#055a0f" }}

                          onClick={() => handleOpenModal2(row)}

                        >
                          <MdDownloadForOffline />

                        </button>
                      </td>
                      <td>{row.Mode_Name}</td>
                      <td>{row.Input_Weight}</td>
                      <td>{row.Flag === "Fixed Rate" ? "-" : row.Rate_PerKg}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          style={{ fontSize: "14px", fontWeight: "bold", color: "#055a0f" }}

                          onClick={() => handleOpenModal(row)}

                        >
                          ₹ {row.Grand_Total}

                        </button>
                      </td>

                      <td>{row.City_Name}</td>
                      <td>{row.Zone_Name}</td>

                      <td>{row.Flag}</td>
                      <td>{row.Customer_Name}</td>
                      <td>{row.Booking_Type}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* ================= PAGINATION ================= */}
          <div className="row" style={{ whiteSpace: "nowrap" }}>
            <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
              <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                {'<'}
              </button>
              <span style={{ color: "#333", padding: "5px" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                {'>'}
              </button>
            </div>

            <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
              <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}

                style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
              >
                <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
              </select>
            </div>
          </div>

          

          <Modal
            isOpen={modalIsOpen}
            className="custom-modal-volumetric"
            overlayClassName="custom-overlay"
            style={{
              overlay: {
                backgroundColor: "rgba(0,0,0,0.6)",
                zIndex: 9998,
              },
              content: {
                height: "90%",
                width: "90%",
                maxWidth: "350px",
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                transform: "translate(-50%, -50%)",
                margin: 0,
                padding: 0,
                overflowY: "auto",
                zIndex: 9999,
              },
            }}
          >


            <div
              className="custom-modal-content"


            >
              <div className="header-tittle">
                <header>Charges Details</header>
              </div>

              <div className="container2">
                {selectedRow && (
                  <table
                    className="table table-bordered table-sm"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <tbody>
                      {[
                        { label: "Basic Rate", value: selectedRow.Freight },
                        {
                          label: "Fov Charges",
                          label2: `(${selectedRow.Fov_Per}%)`,
                          value: selectedRow.Fov_Charges
                        },
                        { label: "Docket Charges", value: selectedRow.Docket_Charges },
                        { label: "Delivery Charges", value: selectedRow.Dilivery_Charges },
                        { label: "Green Charges", value: selectedRow.Green_Charges },
                        { label: "Oda Charges", value: selectedRow.Oda_Charges },
                        { label: "Packing Charges", value: selectedRow.Packing_Charges },
                        { label: "Hamali Charges", value: selectedRow.Hamali_Charges },
                        { label: "Insurance Charges", value: selectedRow.Insurance_Charges },
                        { label: "Clearance Charges", value: selectedRow.Clearance_Charges },
                        { label: "Security Charges", value: selectedRow.Security_Charges },
                        { label: "Transportation Charges", value: selectedRow.Transportation_Charges },
                        { label: "DGR Charges", value: selectedRow.DGR_Charges },
                        { label: "Risk Charges", value: selectedRow.Risk_Charges },
                        { label: "ADC Charges", value: selectedRow.ADC_Charges },
                        { label: "AWB Charges", value: selectedRow.AWB_Charges },
                        { label: "Large Size Charges", value: selectedRow.LargeSize_Charges },
                        { label: "Loading / Unloading", value: selectedRow.Loading_Unloading },
                        { label: "Import Duty Charges", value: selectedRow.Import_Duty_Charges },
                        { label: "Other Charges", value: selectedRow.Other_Charges },

                        {
                          label: "Fuel Charges",
                          label2: `(${selectedRow.Fuel_Per}%)`,
                          value: selectedRow.Fuel_Charges
                        },
                        { label: "Total Amount", value: selectedRow.Total_Amount, alwaysShow: true },
                        {
                          label: "CGST",
                          label2: `(${selectedRow.CGST_Per}%)`,
                          value: selectedRow.CGST
                        },

                        {
                          label: "SGST",
                          label2: `(${selectedRow.SGST_Per}%)`,
                          value: selectedRow.SGST
                        },

                        {
                          label: "IGST",
                          label2: `(${selectedRow.IGST_Per}%)`,
                          value: selectedRow.IGST
                        },

                        {
                          label: "Total GST",
                          label2: `(${selectedRow.Total_GST_Per}%)`,
                          value: selectedRow.Total_GST
                        },

                        // Grand Total
                        {
                          label: "Grand Total",
                          value: `₹ ${selectedRow.Grand_Total}`,
                          alwaysShow: true
                        }
                      ]
                        .filter((item) => item.alwaysShow || item.value > 0)
                        .map((item, index) => (
                          <tr key={index}>
                            <td className='td'>
                              <div style={{ display: "flex", justifyContent: "space-between" }}><span>{item.label}</span> <span>{item.label2}</span>
                              </div>
                            </td>
                            <td>
                              {item.label === "Grand Total" ? (
                                <b>{item.value}</b>
                              ) : (
                                item.value
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}

                <div className="bottom-buttons">
                  <button
                    onClick={() => {
                      setModalIsOpen(false);
                      switchToBooking(selectedRow);
                    }}

                    className="ok-btn"
                    style={{ width: "120px" }}
                  >
                    Book Now
                  </button>
                  <button
                    onClick={() => setModalIsOpen(false)}
                    className="ok-btn"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </Modal>


           <Modal
            isOpen={modalIsOpen3}
            className="custom-modal-volumetric"
            overlayClassName="custom-overlay"
            style={{
              overlay: {
                backgroundColor: "rgba(0,0,0,0.6)",
                zIndex: 9998,
              },
              content: {
                height: "90%",
                width: "90%",
                maxWidth: "380px",
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                transform: "translate(-50%, -50%)",
                margin: 0,
                padding: 0,
                overflowY: "hidden",
                zIndex: 9999,
              },
            }}
          >


            <div
              className="custom-modal-content"


            >
              <div className="header-tittle">
                <header>Rate Details</header>
              </div>

               <div
  className="container2"

>

  <div  style={{
    overflowY: "auto",
    width:"100%",
  }}
>

  
                {selectedRow2
                 && 
          <div id='download' style={{ padding: "10px",width: "380px"}} width>
            
            <div style={{ border: "1px solid black", width: "100%" }}>

              <div style={{ width: "100%", display: "flex", justifyContent: "space-around", alignItems: "center", backgroundColor: "#eff2ff" }}>
                <div style={{ display: "flex", width: "100px", height: "40px", justifyContent: "center", alignItems: "center" }}>
                  <img src={selectedRow2?.Vendor_Img} alt="" style={{ width: "100%", height: "100%" }} />
                </div>
                <div style={{ fontWeight: "bold" }}>{selectedRow2?.Vendor_Name}</div>
                <div style={{ borderLeft: "1px solid gray", paddingLeft: "15px", color: "#002357", fontWeight: "bold" }}>
                  {selectedRow2?.Dox_Spx}
                </div>

              </div>
              <table
                className="table table-bordered table-sm"
                style={{ whiteSpace: "nowrap", margin: "0px" }}
              >
                <tbody>
                  {[
                    { label: "Country", value: selectedRow2.City_Name, alwaysShow: true },
                    { label: "Mode", value: selectedRow2.Mode_Name, alwaysShow: true },
                    { label: "Weight", value: selectedRow2.Input_Weight, alwaysShow: true },
                    { label: "Basic Rate", value: selectedRow2.Freight, alwaysShow: true },
                    {
                      label: "Fov Charges",
                      label2: `(${selectedRow2.Fov_Per}%)`,
                      value: selectedRow2.Fov_Charges
                    },
                    { label: "Docket Charges", value: selectedRow2.Docket_Charges },
                    { label: "Delivery Charges", value: selectedRow2.Dilivery_Charges },
                    { label: "Green Charges", value: selectedRow2.Green_Charges },
                    { label: "Oda Charges", value: selectedRow2.Oda_Charges },
                    { label: "Packing Charges", value: selectedRow2.Packing_Charges },
                    { label: "Hamali Charges", value: selectedRow2.Hamali_Charges },
                    { label: "Insurance Charges", value: selectedRow2.Insurance_Charges },
                    { label: "Clearance Charges", value: selectedRow2.Clearance_Charges },
                    { label: "Security Charges", value: selectedRow2.Security_Charges },
                    { label: "Transportation Charges", value: selectedRow2.Transportation_Charges },
                    { label: "DGR Charges", value: selectedRow2.DGR_Charges },
                    { label: "Risk Charges", value: selectedRow2.Risk_Charges },
                    { label: "ADC Charges", value: selectedRow2.ADC_Charges },
                    { label: "AWB Charges", value: selectedRow2.AWB_Charges },
                    { label: "Large Size Charges", value: selectedRow2.LargeSize_Charges },
                    { label: "Loading / Unloading", value: selectedRow2.Loading_Unloading },
                    { label: "Import Duty Charges", value: selectedRow2.Import_Duty_Charges },
                    { label: "Other Charges", value: selectedRow2.Other_Charges },

                    {
                      label: "Fuel Charges",
                      label2: `(${selectedRow2.Fuel_Per}%)`,
                      value: selectedRow2.Fuel_Charges
                    },
                    { label: "Total Amount", value: selectedRow2.Total_Amount, alwaysShow: true },
                    {
                      label: "CGST",
                      label2: `(${selectedRow2.CGST_Per}%)`,
                      value: selectedRow2.CGST
                    },

                    {
                      label: "SGST",
                      label2: `(${selectedRow2.SGST_Per}%)`,
                      value: selectedRow2.SGST
                    },

                    {
                      label: "IGST",
                      label2: `(${selectedRow2.IGST_Per}%)`,
                      value: selectedRow2.IGST
                    },

                    {
                      label: "Total GST",
                      label2: `(${selectedRow2.Total_GST_Per}%)`,
                      value: selectedRow2.Total_GST
                    },
                    {
                      label: "Grand Total",
                      alwaysShow: true,
                      value: `₹ ${selectedRow2.Grand_Total}`
                    },


                  ]
                    .filter((item) => item.alwaysShow || item.value > 0)
                    .map((item, index) => (
                      <tr
                        key={index}
                        style={
                          item.label === "Grand Total"
                            ? {
                              backgroundColor: "#eff2ff",
                              color: "#002357",
                              fontWeight: "bold",
                              fontSize: "16px"
                            }
                            : {}
                        }
                      >
                        <td className="td">
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={
                              item.label === "Grand Total"
                                ? {
                                  color: "#002357",
                                  fontWeight: "bold",
                                  fontSize: "16px"
                                }
                                : {}
                            }>{item.label}</span>
                            <span>{item.label2}</span>
                          </div>
                        </td>

                        <td >
                          <span style={
                            item.label === "Grand Total"
                              ? {
                                color: "#002357",
                                fontWeight: "bold",
                                fontSize: "16px"
                              }
                              : {}
                          }>
                            {item.value}
                          </span>

                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>}
          </div>

                <div className="bottom-buttons">
                  <button
                    onClick={() => {
                      setModalIsOpen(false);
                      handleDownload();
                    }}

                    className="ok-btn"
                    style={{ width: "120px" }}
                  >
                    Download
                  </button>
                  <button
                    onClick={() => setModalIsOpen3(false)}
                    className="ok-btn"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen2}
            style={{
              content: {
                width: '90%',
                top: '50%',             // Center vertically
                left: '50%',
                height: "auto",
                whiteSpace: "nowrap"
              },
            }}
            className="custom-modal-mode" contentLabel="Modal">
            <div className="custom-modal-content">
              <div className="header-tittle">
                <header>Volumetric Calculate</header>
              </div>
              <div className='container2'>
                <div className="table-container" style={{ padding: "10px" }}>
                  <table className="table table-bordered table-sm">
                    <thead className="table-info custom-th">
                      <tr>
                        <th>Length</th>
                        <th>Width</th>
                        <th>Height</th>
                        <th>DIV</th>
                        <th>QTY</th>
                        <th>Volumetric Wt</th>
                        <th>Actual Wt</th>
                        <th>Charged Wt</th>
                        <th className="w-60">Action</th>
                      </tr>
                    </thead>
                    <tbody className="table-body">
                      <tr className='tr-input'>
                        <td>
                          <input type="tel" className="input" placeholder="Length" name="Length"
                            style={{ textAlign: "center" }} value={volumetricData.Length}
                            onChange={handleChange} />
                        </td>
                        <td>
                          <input type="tel" className="input" placeholder="Width" name="Width"
                            style={{ textAlign: "center" }} value={volumetricData.Width}
                            onChange={handleChange} />
                        </td>
                        <td>
                          <input type="tel" className="input" placeholder="Height" name="Height"
                            style={{ textAlign: "center" }} value={volumetricData.Height}
                            onChange={handleChange} />
                        </td>
                        <td>
                          <input type="tel" className="input" placeholder="DIV" name="DivideBy"
                            style={{ textAlign: "center" }} value={volumetricData.DivideBy}
                            onChange={handleChange} />
                        </td>
                        <td>
                          <input type="tel" className="input" placeholder="QTY" name="Qty"
                            style={{ textAlign: "center" }} value={volumetricData.Qty}
                            onChange={handleChange} />
                        </td>
                        <td>
                          <input type="tel" className="input" placeholder="Vol Wt" name="VolmetricWt"
                            style={{ textAlign: "center" }} value={volumetricData.VolmetricWt}
                            onChange={handleChange} />
                        </td>
                        <td>
                          <input type="tel" className="input" placeholder="Actual Wt" name="ActualWt"
                            style={{ textAlign: "center" }} value={volumetricData.ActualWt}
                            onChange={handleChange} />
                        </td>
                        <td>
                          <input type="tel" className="input" placeholder="Charged Wt" name="ChargeWt"
                            style={{ textAlign: "center" }} value={volumetricData.ChargeWt}
                            onChange={handleChange} />
                        </td>
                        <td>

                          <button className="ok-btn" style={{ width: "40px", height: "30px", margin: "0px 10px", marginTop: "3.2px", paddingTop: "2px", fontSize: "30px" }}
                            onClick={handleAddRow}>
                            <i className="bi bi-plus" style={{ fontSize: "22px" }}></i>
                          </button>
                        </td>
                      </tr>

                      {submittedData.map((data, index) => (
                        <tr key={index}>
                          <td>{data.Length}</td>
                          <td>{data.Width}</td>
                          <td>{data.Height}</td>
                          <td>{data.DivideBy}</td>
                          <td>{data.Qty}</td>
                          <td>{data.VolmetricWt}</td>
                          <td>{data.ActualWt}</td>
                          <td>{data.ChargeWt}</td>
                          <td className='w-60'>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                              <button className='edit-btn'
                                onClick={() => {
                                  setVolumetricData({
                                    Length: data.Length,
                                    Width: data.Width,
                                    Height: data.Height,
                                    Qty: data.Qty,
                                    DivideBy: data.DivideBy,
                                    VolmetricWt: data.VolmetricWt,
                                    ActualWt: data.ActualWt,
                                    ChargeWt: data.ChargeWt,
                                  })
                                  setEditIndex(index);
                                }}>
                                <i className='bi bi-pen'></i>
                              </button>
                              <button onClick={() => {
                                setSubmittedData(submittedData.filter((_, ind) => ind !== index));
                                setEditIndex(null);
                                setVolumetricData({
                                  Length: 0,
                                  Width: 0,
                                  Height: 0,
                                  Qty: 0,
                                  DivideBy: "",
                                  VolmetricWt: 0,
                                  ActualWt: 0,
                                  ChargeWt: 0
                                });
                              }}
                                className='edit-btn'><i className='bi bi-trash'></i></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <form action="" style={{ backgroundColor: "white", justifyContent: "center" }}>
                  <div className="fields2">
                    <div className="input-field1">
                      <label htmlFor="">Total Vol. Weight</label>
                      <input type="text" className='input' placeholder="Total Vol. Weight" value={totalVolWt1} readOnly />
                    </div>

                    <div className="input-field1">
                      <label htmlFor="">Total Act. Weight</label>
                      <input type="text" className='input' placeholder="Total Act. Weight" value={totalActWt1} readOnly />
                    </div>

                    <div className="input-field1">
                      <label htmlFor="">Total Cha. Weight</label>
                      <input type="text" className='input' placeholder="Total Cha. Weight" value={totalChargeWt1} readOnly />
                    </div>
                  </div>
                </form>

                <div className="bottom-buttons">
                  <button className="ok-btn" onClick={() => setModalIsOpen2(false)}>Submit</button>
                  <button className="ok-btn" onClick={() => setModalIsOpen2(false)}>Cancel</button>
                </div>
              </div>


            </div>
          </Modal >


        </div>
      </div>
    </>

  );
}

export default RateCal;